//  Accepts Image or PDF file types
import PDFJS from 'pdfjs-dist';
PDFJS.GlobalWorkerOptions.workerSrc = 'https://mozilla.github.io/pdf.js/build/pdf.worker.js';

export default function(file) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image') && !file.type == 'application/pdf') {
      console.log('incorrect file type');
      reject('Incorrect file type');
    }

    if (file.type.startsWith('image')) {
      const max = 200;
      const reader = new FileReader();
      reader.onload = function(event) {
        console.log('render onload');
        const img = new Image();
        img.onload = function() {
          console.log('img on load');
          const oc = document.createElement('canvas');
          let result;
          if (img.width > max) {
            const octx = oc.getContext('2d');
            oc.width = img.width;
            oc.height = img.height;
            octx.drawImage(img, 0, 0);
            if (img.width > img.height) {
              oc.height = (img.height / img.width) * max;
              oc.width = max;
            } else {
              oc.width = (img.width / img.height) * max;
              oc.height = max;
            }
            octx.drawImage(oc, 0, 0, oc.width, oc.height);
            octx.drawImage(img, 0, 0, oc.width, oc.height);
            result = oc.toDataURL('image/jpeg');
          } else {
            result = oc.toDataURL('image/jpeg');
          }
          resolve(result);
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    } else {
      //  HANDLE PDF THUMBNAIL
      console.log('hanlde  pdf');
      const fileReader = new FileReader();
      fileReader.onload = function() {
        console.log('file reader loaded')
        var pdfData = new Uint8Array(this.result);
        const loadingTask = PDFJS.getDocument({ data: pdfData });
        loadingTask.promise
          .then(function(doc) {
            doc
              .getPage(1)
              .then(makeThumb)
              .then(function(canvas) {
                resolve(canvas.toDataURL('image/jpg'));
              })
              .catch(e => {
                console.log(e);
                reject(e);
              });
            // //var pages = []; while (pages.length < doc.numPages) pages.push(pages.length + 1);
            // const pages = [1];
            // return Promise.all(pages.map(function (num) {
            //   // create a div for each page and build a small canvas for it
            //   var div = document.createElement("div");
            //   document.body.appendChild(div);
            //   return doc.getPage(num).then(makeThumb)
            //     .then(function (canvas) {
            //       canvas.toDataURL('image/jpg');

            //   });
            // }));
          })
          .catch(e => {
            console.log(e);
            reject(e);
          });
      };
      console.log('read file');
      fileReader.readAsArrayBuffer(file);
    }
  });

  function makeThumb(page) {
    console.log('make thumb');
    const max = 200;
    // draw page to fit into 96x96 canvas
    var vp = page.getViewport(1);
    var canvas = document.createElement('canvas');
    //  max 200 pixels on either dimension
    let scale;
    if (vp.width > vp.height) {
      scale = max / vp.width;
    } else {
      scale = max / vp.height;
    }
    canvas.width = vp.width * scale;
    canvas.height = vp.height * scale;
    //var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
    return page
      .render({ canvasContext: canvas.getContext('2d'), viewport: page.getViewport(scale) })
      .promise.then(function() {
        return canvas;
      });
  }
}
